import { FILTER_FIELD_REGISTRY } from './fields/filterFieldRegistry';
import type { FilterFieldProps } from './FilterField.types';

export type { FilterFieldProps, FilterVariant } from './FilterField.types';
export { SectionLabel, FieldLabel, FieldHint, FieldError } from './FilterFieldHelpers';
export { TextFilterInput } from './fields/TextFilterInput';
export { DateFilterInput } from './fields/DateFilterInput';
export { NumericFilterInput } from './fields/NumericFilterInput';
export { BooleanFilterInput } from './fields/BooleanFilterInput';
export { ListFilterInput } from './fields/ListFilterInput';

/**
 * Agnostic filter field dispatcher.
 *
 * Looks up the strategy for `def.kind` in FILTER_FIELD_REGISTRY and renders it.
 * Use this when the kind is determined at runtime (e.g. driven by column definitions).
 *
 * For static use where the kind is known at compile time, import the strategy
 * component directly:
 *   import { BooleanFilterInput } from 'components/filters/FilterField';
 */
export function FilterField(props: FilterFieldProps) {
  const Component = FILTER_FIELD_REGISTRY[props.def.kind];
  return <Component {...props} />;
}
